import ReactCardFlip from "react-card-flip";
import { useEffect, useState } from "react";
import BugInfo from "./BugInfo";

function App() {
  const [isFlipped, setIsFlipped] = useState(false);
  const [bug, setBug] = useState(null);
  const [showBugInfo, setShowBugInfo] = useState(false);
  const [bugs, setBugs] = useState([]);
  const tz = "America/Toronto";

  // "YYYY-MM-DD" in Toronto time (handles DST)
  function getTorontoDateKey(d = new Date()) {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(d);
    // en-CA gives YYYY-MM-DD already
    return parts; // e.g. "2025-11-05"
  }

  // Friendly date string for display (Toronto time)
  function getTorontoPrettyDate() {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    })
      .format(new Date())
      .toLowerCase();
  }
  function revealBug() {
    setIsFlipped(true);
    setTimeout(() => {
      setShowBugInfo(true);
    }, 1000);
  }

  // Choose (or retrieve) the daily bug
  function chooseDailyBug(allBugs, dateKey) {
    const storageKey = `dailyBug:${dateKey}`;
    const saved = localStorage.getItem(storageKey);

    if (saved) {
      // We store the bug's name (or id if you have one) to survive list reordering
      const savedName = JSON.parse(saved)?.name;
      const found = allBugs.find((b) => b.name === savedName);
      if (found) return found;
      // Fallback if the saved bug is no longer in the list: hash the date
    }

    // Pick randomly for the day, then save by name
    const picked = allBugs[Math.floor(Math.random() * allBugs.length)];
    localStorage.setItem(storageKey, JSON.stringify({ name: picked.name }));
    return picked;
  }

  // Load bugs and set today's bug
  useEffect(() => {
    let alive = true;
    fetch("/bugs.json")
      .then((res) => res.json())
      .then((data) => {
        if (!alive) return;
        setBugs(data);
        const todayKey = getTorontoDateKey();
        const todayBug = chooseDailyBug(data, todayKey);
        setBug(todayBug);
      })
      .catch((e) => {
        console.error("Failed to load bugs.json", e);
      });
    return () => {
      alive = false;
    };
  }, []);

  // Watch for date rollover in Toronto time and update bug at midnight
  useEffect(() => {
    if (!bugs.length) return;

    let lastKey = getTorontoDateKey();
    const id = setInterval(() => {
      const newKey = getTorontoDateKey();
      if (newKey !== lastKey) {
        lastKey = newKey;
        const newBug = chooseDailyBug(bugs, newKey);
        setIsFlipped(false);
        setShowBugInfo(false);
        setBug(newBug);
      }
    }, 60 * 1000); // check once per minute

    return () => clearInterval(id);
  }, [bugs]);

  return (
    <div className="mx-5 my-10">
      <div className="flex flex-col justify-center items-center gap-5">
        <h1 className="text-3xl text-center font-bold">
          what bug are you today?
        </h1>
        <p className="text-center text-gray-800">{getTorontoPrettyDate()}</p>
        <div>
          <ReactCardFlip isFlipped={isFlipped}>
            <div
              className="w-64 h-40 bg-pink-300 flex items-center justify-center rounded-xl shadow-lg cursor-pointer"
              onClick={() => revealBug()}
            >
              click to find out!
            </div>

            <div className="w-64 h-40 bg-blue-300 flex items-center justify-center rounded-xl shadow-lg">
              <img
                className="w-64 h-40 border-4 border-white rounded-xl"
                src={bug?.image}
                alt={bug?.name}
              />
            </div>
          </ReactCardFlip>
        </div>

        {showBugInfo && (
          <>
            <BugInfo bug={bug} />
          </>
        )}
      </div>
    </div>
  );
}

export default App;
